import { templateJoin } from 'bernie-graphql';

export const flightsFlexibleSearchQuery = templateJoin`
        query FlightsFlexibleSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchPreferences: FlightsSearchPreferencesInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchPreferences: $searchPreferences
    travelerDetails: $travelerDetails
  ) {
    flexibleSearchResponse {
      title
      subTitle
      titleAccessibility
      searchTriggerAction
      analytics {
        priceFillRate
      }
      departureLegend {
        icon {
          description
          id
        }
        labelText
        accessibility
      }
      resultsGrid {
        results {
          ...FlightsFlexSearchHeaderCell
          ...FlightsFlexSearchLegendCell
          ...FlightsFlexSearchResults
        }
      }
      coverageAnalytics {
        ...FlightsAnalyticsFlexSearch
      }
      gridTrigger {
        collapseAnalytics {
          ...FlightsAnalyticsFlexSearch
        }
        expandAnalytics {
          ...FlightsAnalyticsFlexSearch
        }
      }
    }
  }
}

fragment FlightsFlexSearchResults on FlightsFlexibleSearchResultCell {
  valueText
  labelText
  theme
  summary
  journeyDate
  accessibility {
    highlightDescription
    selectionDescription
  }
  nextSearchCriteria {
    ...FlightsNextJourneyCriteriaValues
  }
  selectAnalytics {
    ...FlightsAnalyticsFlexSearch
  }
}

fragment FlightsNextJourneyCriteriaValues on FlightsNextJourneyCriteriaValues {
  journeyCriteria {
    destination
    departureDate {
      day
      month
      year
    }
    origin
  }
  searchPreferences {
    cabinClass
  }
}

fragment FlightsFlexSearchLegendCell on FlightsFlexibleSearchLegendCell {
  accessibilityMessage {
    usage
  }
  icon {
    description
    id
  }
  valueText
  legendTheme: theme
}

fragment FlightsFlexSearchHeaderCell on FlightsFlexibleSearchHeaderCell {
  labelText
  valueText
  headerTheme: theme
}

fragment FlightsAnalyticsFlexSearch on FlightsAnalytics {
  linkName
  rfrr: referrerId
}

    `;

export const flightsShoppingPwaFlightInformationResultsQuery = templateJoin`
        query FlightsShoppingPwaFlightInformationResults(
  $context: ContextInput!
  $flightsDetailCriteria: FlightsDetailCriteriaInput!
  $queryState: FlightsQueryState
) {
  flightsDetail(context: $context, flightsDetailCriteria: $flightsDetailCriteria, queryState: $queryState) {
    analytics {
      footerOnViewedAnalytics {
        ...FlightsAnalyticsInformationLoaded
      }
    }
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalyticsInformationLoaded
        }
      }
    }
    flightsOpinionLab {
      ... on FlightsActionAndLabel {
        label
        selectAction {
          ...FlightsActionInformationLoaded
        }
      }
    }
    pageTitle {
      ... on FlightsPageTitle {
        title {
          longMessage
          shortMessage
        }
        pageAccessibility
      }
    }
    messagingCards {
      __typename
      ...FlightsIconPlacardInformationLoaded
      ...FlightsImagePlacardInformationLoaded
    }
    banners {
      ...FlightsIconPlacardInformationLoaded
    }
    freeCancellation {
      ...FlightsImagePlacardInformationLoaded
    }
    flightsSelectedJourneyReview {
      __typename
      ... on LoadedFlightsSelectedJourneyReview {
        flightsJourneyInformation {
          details {
            ...FlightsToggleInformationLoaded
          }
          flightJourneyDetails {
            journeyParts {
              connectionAdditionalInformation {
                durationAndStop
                nextFlightOriginAirport
              }
              flightsConnectionInformation {
                flightsConnection {
                  aircraftModel
                  airlineInfo
                  cabinClassAndBookingCode
                  connectionArrival {
                    ...CoordinateInformationInformationLoaded
                  }
                  connectionDeparture {
                    ...CoordinateInformationInformationLoaded
                  }
                  duration
                  journeyAmenities {
                    accessibilityMessage
                    amenities {
                      accessibility
                      icon {
                        ...IconInformationLoaded
                      }
                      label
                    }
                    analytics {
                      ...FlightsAnalyticsInformationLoaded
                    }
                  }
                }
                governmentApprovalMessage
              }
            }
          }
        }
        flightsJourneyHeaders {
          flightsJourneySubheading
          flightsJourneySubheadingImage {
            description
            url
          }
          heading
        }
        flightsJourneySummary {
          __typename
          heading {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          differentDayArrival {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          basicFlightDetails {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          ... on FlightsBargainJourneySummary {
            arrivalDayInformation
          }
        }
        onViewedAnalytics {
          ...FlightsAnalyticsInformationLoaded
        }
        changeFlight {
          ...FlightsActionInformationLoaded
        }
        fareDetails {
          changePolicies {
            ...FlightsInformationTextSectionLoaded
          }
          fareSummary {
            message
            title
            flightsSelectedJourneyAvailableFaresInformation {
              fareChoiceInformation {
                accessibleHeading
                heading {
                  longMessage
                  shortMessage
                }
                message
                tripTypePerTraveler
                displayAnalytics {
                  ...FlightsAnalyticsInformationLoaded
                }
                scrollAnalytics {
                  ...FlightsAnalyticsInformationLoaded
                }
                fareTypes {
                  name
                  cabinClass
                  accessibilityMessage
                  formattedPrice {
                    completeText
                    items {
                      text
                      styles
                    }
                  }
                  totalPrice
                  identifier
                  selected
                  clickEventAnalytics {
                    ...FlightsAnalyticsInformationLoaded
                  }
                  fareScrollAnalytics {
                    ...FlightsAnalyticsInformationLoaded
                  }
                  collapsedRules {
                    accessibilityMessage
                    amenities {
                      icon {
                        description
                        id
                        withBackground
                      }
                      label
                    }
                    analytics {
                      ...FlightsAnalyticsInformationLoaded
                    }
                  }
                  expandedRules {
                    label
                    rules {
                      accessibilityMessage
                      amenities {
                        icon {
                          description
                          id
                          withBackground
                        }
                        label
                      }
                      analytics {
                        ...FlightsAnalyticsInformationLoaded
                      }
                    }
                  }
                  baggageFeesInformation {
                    ...FlightsBaggageInformation
                  }
                  showMoreToggle {
                    ...FlightsToggleInformationLoaded
                  }
                  showMoreAmenitiesToggle {
                    ...FlightsToggleInformationLoaded
                  }
                  changeCancellationMessages {
                    heading
                    displayAction {
                      ...FlightsToggleInformationLoaded
                    }
                    messages {
                      ...FlightsInformationLoadedPhrase
                    }
                    onViewedAnalytics {
                      ...FlightsAnalyticsInformationLoaded
                    }
                    displayAnalytics {
                      ...FlightsAnalyticsInformationLoaded
                    }
                  }
                  chooseFareAction {
                    ...FlightsActionInformationLoaded
                  }
                  recommendation {
                    text
                    type
                  }
                }
                defaultBaggageInformation {
                  ...FlightsBaggageInformation
                }
              }
              dismissDetailedJourneyInformation {
                analytics {
                  ...FlightsAnalyticsInformationLoaded
                }
                icon {
                  ...IconInformationLoaded
                }
              }
              openAccessibility
            }
            details {
              ...FlightsActionInformationLoaded
            }
          }
          defaultBaggageInformation {
            ...FlightsBaggageInformation
          }
        }
        flightsJourneyPolicies {
          ...FlightsInformationTextSectionLoaded
        }
        journeyInformation {
          ...JourneyInformation
        }
        hygieneAmenitiesPresentation {
          displayAction {
            displayAction {
              collapseActionable {
                action
                analytics {
                  ...FlightsAnalyticsInformationLoaded
                }
              }
              expandActionable {
                action
                analytics {
                  ...FlightsAnalyticsInformationLoaded
                }
              }
              expanded
            }
          }
          airlineAmenityGroups {
            headerText
            amenities {
              icon {
                id
              }
              label
              subLabel
            }
          }
          disclaimerMessage
        }
      }
    }
    priceSummary {
      ...FlightsLoadedPriceSummary
    }
    separateTicketBanner {
      ...FlightsIconPlacardInformationLoaded
    }
    brandPolicies {
      ...FlightsInformationTextSectionLoaded
    }
    serverErrorMessaging {
      ...FlightsInformationServerErrorMessaging
    }
    dynamicElementsGroups {
      identifier
      dynamicElements {
        flightsJourneyDetailsDynamicElements {
          fareName
          journeyPartsDynamicElements {
            cabinClassAndBookingCode
          }
        }
        ... on FlightsInformationDynamicElements {
          priceSummary {
            ...FlightsLoadedPriceSummary
          }
          totalPrice
          fareChoiceInformationDynamicElement {
            farePricePerPerson
          }
        }
      }
    }
  }
}
fragment FlightsLoadedPriceSummary on FlightsLoadedPriceSummary {
  __typename
  breakdown {
    ...FlightsPriceSummaryGroupLoaded
  }
  buttonAction {
    ...FlightsActionInformationLoaded
  }
  dismiss {
    ...FlightsActionableInformationIconLoaded
  }
  policies {
    ...FlightsInformationTextSectionLoaded
  }
  title
  tripTotalLabel
  totals {
    ...FlightsPriceSummaryGroupLoaded
  }
  tripTotalDetails {
    ...FlightsLoadedPriceSummaryTripTotalItem
  }
  viewPriceSummary {
    ...FlightsActionInformationLoaded
  }
}

fragment FlightsInformationServerErrorMessaging on FlightsActionableErrorMessaging {
  action {
    ...FlightsActionInformationLoaded
  }
  icon {
    ...IconInformationLoaded
  }
  message
  title
}

fragment FlightsMessageAndAccessibilityInformationLoaded on FlightsMessageAndAccessibility {
  __typename
  text
  accessibilityMessage
}

fragment FlightsToggleInformationLoaded on FlightsToggle {
  collapseActionable {
    ...TogglePhaseInformationLoaded
  }
  expandActionable {
    ...TogglePhaseInformationLoaded
  }
  expanded
}
fragment IconInformationLoaded on Icon {
  description
  id
  size
  withBackground
}

fragment TogglePhaseInformationLoaded on TogglePhase {
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalyticsInformationLoaded
  }
  icon {
    ...IconInformationLoaded
  }
}

fragment CoordinateInformationInformationLoaded on CoordinateInformation {
  icon {
    ...IconInformationLoaded
  }
  overnightMessage
  subtitle
  title
}

fragment FlightsImagePlacardInformationLoaded on FlightsImagePlacard {
  __typename
  image {
    url
    description
  }
  heading
  message
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
}

fragment FlightsIconPlacardInformationLoaded on FlightsIconPlacard {
  heading
  message
  icon {
    description
    id
    withBackground
    size
  }
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
}

fragment FlightsActionInformationLoaded on FlightsAction {
  accessibilityMessage
  accessibilityCheckoutMessage
  analytics {
    ...FlightsAnalyticsInformationLoaded
  }
  analyticsList {
    ...FlightsAnalyticsInformationLoaded
  }
  displayAction
  displayType
  enable
  relativePackageableURI {
    relativePath
    value
  }
  relativeURI {
    relativePath
    value
  }
  type
  displayAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
}

fragment FlightsAnalyticsInformationLoaded on FlightsAnalytics {
  linkName
  rfrr: referrerId
}

fragment FlightsPriceSummaryGroupLoaded on FlightsPriceSummaryGroup {
  accessibilityMessage
  entries {
    ...FlightsPriceSummaryLoadedItem
  }
  title {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsPriceSummaryLoadedItem on FlightsPriceSummaryItem {
  label
  price
  roundedPrice
}

fragment FlightsActionableInformationIconLoaded on FlightsActionableIcon {
  analytics {
    ...FlightsAnalyticsInformationLoaded
  }
  icon {
    ...IconInformationLoaded
  }
  type
}

fragment FlightsInformationTextSectionLoaded on FlightsTextSection {
  displayAction {
    ...FlightsToggleInformationLoaded
  }
  heading
  messages {
    ...FlightsInformationLoadedPhrase
  }
  onViewedAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
  displayAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
}

fragment FlightsInformationLoadedPhrase on FlightsPhrase {
  completeText
  delimeter
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalyticsInformationLoaded
      }
      displayAnalytics {
        ...FlightsAnalyticsInformationLoaded
      }
      link
      icon
    }
  }
}

fragment FlightsLoadedPriceSummaryTripTotalItem on FlightsPriceSummaryTripTotalItem {
  ratesCurrencyMessage
  tripTotal {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsBaggageInformation on FlightsBaggageInformation {
  label
  defaultBagSelectionMessage
  bagFeesMoreInfo {
    ...FlightsInformationLoadedPhrase
  }
  displayAnalytics {
    ...FlightsAnalyticsInformationLoaded
  }
  displayDetailsAction
  dismissAction
  details {
    ...FlightsBaggageInformationDetail
  }
}

fragment FlightsBaggageInformationDetail on FlightBaggageInformationDetail {
  topic
  detail
}

fragment JourneyInformation on JourneyInformation {
  destinationAirportCode
  originAirportCode
  tripType
}

    `;

export const flightsShoppingPwaFlightInformationResultsLoadingQuery = templateJoin`
        query FlightsShoppingPwaFlightInformationResultsLoading(
  $context: ContextInput!
  $flightsDetailCriteria: FlightsDetailCriteriaInput!
  $queryState: FlightsQueryState
) {
  flightsDetail(context: $context, flightsDetailCriteria: $flightsDetailCriteria, queryState: $queryState) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalyticsInformationLoading
        }
      }
    }
    pageTitle {
      ... on FlightsPageTitle {
        title {
          longMessage
          shortMessage
        }
        pageAccessibility
      }
    }
    freeCancellation {
      ...FlightsImagePlacardInformationLoading
    }
    flightsSelectedJourneyReview {
      ... on LoadingFlightsSelectedJourneyReview {
        flightsJourneyHeaders {
          heading
          flightsJourneySubheadingImage {
            url
            description
          }
          flightsJourneySubheading
        }
        flightsJourneySummary {
          __typename
          heading {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          differentDayArrival {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          basicFlightDetails {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          ... on LoadingFlightsStandardJourneySummary {
            skeletonCount
          }
          ... on FlightsBargainJourneySummary {
            arrivalDayInformation
          }
        }
        fareSummarySkeletonCount
        changeFlight {
          ...FlightsActionInformationLoading
        }
      }
    }
    priceSummary {
      __typename
      ... on FlightsLoadingPriceSummary {
        title
        skeletonCount
        tripTotalLabel
        buttonAction {
          ...FlightsActionInformationLoading
        }
      }
    }
    serverErrorMessaging {
      ...FlightsInformationLoadingServerErrorMessaging
    }
    stepIndicator {
      ...FlightsInformationStepIndicator
    }
  }
}

fragment FlightsInformationStepIndicator on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalyticsInformationLoading
  }
  journeyContinuationId
}

fragment FlightsInformationLoadingServerErrorMessaging on FlightsActionableErrorMessaging {
  action {
    ...FlightsActionInformationLoading
  }
  icon {
    ...IconInformationLoading
  }
  message
  title
}

fragment IconInformationLoading on Icon {
  id
}

fragment FlightsMessageAndAccessibilityInformationLoading on FlightsMessageAndAccessibility {
  text
  accessibilityMessage
}

fragment FlightsImagePlacardInformationLoading on FlightsImagePlacard {
  __typename
  image {
    url
    description
  }
  heading
  message
}

fragment FlightsActionInformationLoading on FlightsAction {
  accessibilityMessage
  analytics {
    ...FlightsAnalyticsInformationLoading
  }
  displayAction
  displayType
  enable
  relativePackageableURI {
    relativePath
    value
  }
  relativeURI {
    relativePath
    value
  }
  type
}

fragment FlightsAnalyticsInformationLoading on FlightsAnalytics {
  linkName
  rfrr: referrerId
}

    `;

export const flightsShoppingPwaFlightSearchResultsFlightsSearchQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchResultsFlightsSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $searchPagination: PaginationInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    searchPagination: $searchPagination
  ) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
        responseTags
      }
    }
    failedRequestMessaging {
      icon {
        description
        id
      }
      message
      action {
        ...FlightAction
      }
      title
    }
    noListingMessaging {
      ... on FlightsNoFlightsFoundMessaging {
        __typename
        icon {
          id
          description
        }
        message
        title
      }
      ... on FlightsNoFlightsFoundWithFilterMessaging {
        __typename
        icon {
          id
          description
        }
        message
        clearFiltersAction {
          ...FlightAction
        }
        title
      }
      ... on FlightsActionableErrorMessaging {
        __typename
        icon {
          description
          id
        }
        message
        action {
          ...FlightAction
        }
        title
      }
    }
    searchForm(queryState: $queryState) {
      ... on FlightsLoadedSearchForm {
        closeActionAccessibility
        accessibilityMessage
        addJourneyAction {
          analytics {
            ...FlightsAnalytics
          }
          displayAction
          displayType
          type
        }
        appliedFilterCount
        collapseFormAnalytics {
          ...FlightsAnalytics
        }
        departureAndReturnDates {
          longMessage
          shortMessage
        }
        errorSummary {
          header
          linkText
          displayAnalytics {
            linkName
            referrerId
          }
          linkAnalytics {
            linkName
            referrerId
          }
        }
        expandFilterAction {
          icon {
            id
            description
          }
          label
        }
        expandFormAnalytics {
          ...FlightsAnalytics
        }
        expandSearchFormAction {
          id
          description
        }
        closeFormAction {
          displayAction
          analytics {
            ...FlightsAnalytics
          }
        }
        journeys {
          departureDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          destinationLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          label {
            initialValue
            template
            tokens
          }
          originLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          returnDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          removeJourneyAction {
            displayAction
            analytics {
              ...FlightsAnalytics
            }
            accessibilityUsageMessage {
              initialValue
              template
              tokens
            }
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
            analytics {
              ...FlightsAnalytics
            }
            accessibilityMessage
            accessibilityUsageMessage {
              initialValue
              template
              tokens
            }
          }
        }
        newJourneyTemplate {
          departureDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
              shortDateFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          destinationLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          originLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          returnDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
              shortDateFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          label {
            initialValue
            template
            tokens
          }
          removeJourneyAction {
            displayAction
            analytics {
              ...FlightsAnalytics
            }
            accessibilityUsageMessage {
              initialValue
              template
              tokens
            }
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
            analytics {
              ...FlightsAnalytics
            }
            accessibilityMessage
            accessibilityUsageMessage {
              initialValue
              template
              tokens
            }
          }
        }
        originAndDestinationLocations
        searchAction
        searchActionAnalytics {
          ...FlightsAnalytics
        }
        searchOptions {
          __typename
          ... on FlightsSearchFormAirlineOption {
            label
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            applyAnalytics {
              ...FlightsAnalytics
            }
            cancelAnalytics {
              ...FlightsAnalytics
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            items {
              airline
              label
              airlineSelectedAnalytics {
                ...FlightsAnalytics
              }
              selected
            }
            selectedItem {
              airline
              label
            }
            closeIcon {
              accessibility
            }
            doneActionAccessibility
          }
          ... on FlightsSearchFormCabinClassOption {
            label
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            items {
              cabinClass
              label
              cabinClassSelectedAnalytics {
                ...FlightsAnalytics
              }
              selected
            }
            selectedItem {
              cabinClass
              label
            }
          }
          ... on FlightsSearchFormMoreFiltersOption {
            label
            icon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            items {
              advancedFilterSelectedAnalytics {
                ...FlightsAnalytics
              }
              advancedFilterRemoveAnalytics {
                ...FlightsAnalytics
              }
              advancedFilterType
              label
              selected
            }
          }
          ... on FlightsSearchFormTravelersOption {
            label
            travelerLimitLabel
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            ageRulesLink {
              analytics {
                ...FlightsAnalytics
              }
              displayAction
              url
            }
            applyAnalytics {
              ...FlightsAnalytics
            }
            cancelAction
            cancelAnalytics {
              ...FlightsAnalytics
            }
            changeAnalytics {
              ...FlightsAnalytics
            }
            adultSelectedAnalytics {
              ...FlightsAnalytics
            }
            childrenSelectedAnalytics {
              ...FlightsAnalytics
            }
            infantSelectedAnalytics {
              ...FlightsAnalytics
            }
            infantLapAnalytics {
              ...FlightsAnalytics
            }
            infantSeatAnalytics {
              ...FlightsAnalytics
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            currentErrors
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            valueTemplate {
              oneTemplate
              manyTemplate
              tokens
              fewTemplate
              otherTemplate
              twoTemplate
              zeroTemplate
            }
            items {
              __typename
              caption
              currentError
              increaseCountAccessibility
              decreaseCountAccessibility
              decreaseCountAnalytics {
                ...FlightsAnalytics
              }
              increaseCountAnalytics {
                ...FlightsAnalytics
              }
              label
              max
              minCount
              travelerAgeSelectorTemplate {
                analytics {
                  ...FlightsAnalytics
                }
                items {
                  label
                  selected
                  value
                }
                label {
                  initialValue
                  template
                  tokens
                }
                placeholder
              }
              travelerAges {
                analytics {
                  ...FlightsAnalytics
                }
                items {
                  label
                  selected
                  value
                }
                label {
                  initialValue
                  template
                  tokens
                }
                placeholder
              }
              travelerCount
              type
              ... on FlightsSearchFormTravelerInfantOptionItem {
                infantsOption {
                  items {
                    label
                    selected
                    type
                  }
                  label
                }
              }
            }
            doneActionAccessibility
            cancelActionAccessibility
          }
          ... on FlightsSearchFormTripTypeOption {
            label
            icon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            items {
              label
              selected
              tripType
              tripTypeSelectedAnalytics {
                ...FlightsAnalytics
              }
            }
          }
        }
      }
    }
    sortAndFilterResult {
      ... on FlightsLoadedSortAndFilterResult {
        title
        appliedFiltersSummary {
          appliedFilters {
            analytics {
              ...FlightsAnalytics
            }
            dismissIcon {
              description
              id
            }
            label
            nextSearchSortFilterCriteria {
              filterCriteria {
                arrivalAirportCodeFilterValue {
                  airportCode
                }
                arrivalTimeFilterValue {
                  timeOfDay
                }
                departureAirportCodeFilterValue {
                  airportCode
                }
                departureTimeFilterValue {
                  timeOfDay
                }
                durationFilterValue {
                  maxDuration
                }
                numOfStopFilterValue {
                  stopInfo {
                    numberOfStops
                    stopFilterOperation
                  }
                }
                preferredAirlineFilterValue {
                  carrierCode
                }
                flexibleChangePolicyBasedFilterValue {
                  policyName
                }
              }
            }
            accessibilityMessage
          }
        }
        applyAction {
          accessibility {
            onCompletion
            usage
          }
          analytics {
            ...FlightsAnalytics
          }
          details
          label
        }
        clearSelectionLabel {
          label
          analytics {
            ...FlightsAnalytics
          }
          accessibility {
            onCompletion
            usage
          }
        }
        clearAllSelectionLabel {
          label
          analytics {
            ...FlightsAnalytics
          }
          accessibility {
            onCompletion
            usage
          }
        }
        dismiss {
          description
          id
        }
        dismissAnalytics {
          ...FlightsAnalytics
        }
        revealAction {
          accessibility {
            onCompletion
            usage
          }
          appliedFilterCount
          iconAndLabel {
            icon {
              description
              id
            }
            label
          }
          enabled
        }
        revealActionAnalytics {
          ...FlightsAnalytics
        }
        sortPresentation {
          __typename
          label
          options {
            accessibility {
              onCompletion
              usage
            }
            analytics {
              ...FlightsAnalytics
            }
            label
            sortType {
              sortOrder
              sortType
            }
          }
          selectedOption {
            label
            sortType {
              sortOrder
              sortType
            }
          }
          selectionActive
        }
        filterPresentation {
          __typename
          accessibility {
            onCompletion
            usage
          }
          options {
            __typename
            ... on FlightsListDisplayFilterOption {
              items {
                selectPositionAnalytics {
                  ...FlightsAnalytics
                }
                accessibility {
                  onCompletion
                  usage
                }
                deselectAnalytics {
                  ...FlightsAnalytics
                }
                flightsSearchFilterValues {
                  arrivalAirportCodeFilterValue {
                    airportCode
                  }
                  arrivalTimeFilterValue {
                    timeOfDay
                  }
                  departureAirportCodeFilterValue {
                    airportCode
                  }
                  departureTimeFilterValue {
                    timeOfDay
                  }
                  durationFilterValue {
                    maxDuration
                  }
                  numOfStopFilterValue {
                    stopInfo {
                      stopFilterOperation
                      numberOfStops
                    }
                  }
                  preferredAirlineFilterValue {
                    carrierCode
                  }
                  flexibleChangePolicyBasedFilterValue {
                    policyName
                  }
                }
                label
                selectAnalytics {
                  ...FlightsAnalytics
                }
                selected
                startingPrice {
                  formatted
                }
                value {
                  __typename
                  ... on FlightsAirportCodeFilterValue {
                    airportCode
                  }
                  ... on FlightsDurationBasedFilterValue {
                    maxDuration
                  }
                  ... on FlightsPreferredAirlineFilterValue {
                    carrierCode
                  }
                  ... on FlightsFlexibleChangePolicyBasedFilterValue {
                    policyName
                  }
                  ... on FlightsStopBasedFilterValue {
                    stopInfo {
                      stopFilterOperation
                      numberOfStops
                    }
                  }
                  ... on FlightsTimeBasedFilterValue {
                    timeOfDay
                  }
                }
              }
              itemsDefaultDisplayCount
              label
              priceFromLabel
              showMoreToggle {
                ...FlightsToggleSearch
              }
              supportsMultipleSelection
              type
            }
            ... on FlightsCardsDisplayFilterOption {
              items {
                accessibility {
                  onCompletion
                  usage
                }
                card {
                  id
                  description
                }
                deselectAnalytics {
                  ...FlightsAnalytics
                }
                flightsSearchFilterValues {
                  arrivalAirportCodeFilterValue {
                    airportCode
                  }
                  arrivalTimeFilterValue {
                    timeOfDay
                  }
                  departureAirportCodeFilterValue {
                    airportCode
                  }
                  departureTimeFilterValue {
                    timeOfDay
                  }
                  durationFilterValue {
                    maxDuration
                  }
                  numOfStopFilterValue {
                    stopInfo {
                      stopFilterOperation
                      numberOfStops
                    }
                  }
                  preferredAirlineFilterValue {
                    carrierCode
                  }
                  flexibleChangePolicyBasedFilterValue {
                    policyName
                  }
                }
                label
                subLabel
                selectAnalytics {
                  ...FlightsAnalytics
                }
                selected
                value {
                  __typename
                  ... on FlightsAirportCodeFilterValue {
                    airportCode
                  }
                  ... on FlightsDurationBasedFilterValue {
                    maxDuration
                  }
                  ... on FlightsPreferredAirlineFilterValue {
                    carrierCode
                  }
                  ... on FlightsFlexibleChangePolicyBasedFilterValue {
                    policyName
                  }
                  ... on FlightsStopBasedFilterValue {
                    stopInfo {
                      stopFilterOperation
                      numberOfStops
                    }
                  }
                  ... on FlightsTimeBasedFilterValue {
                    timeOfDay
                  }
                }
              }
              label
              type
              supportsMultipleSelection
            }
          }
          title
          emptyFiltersMessage
        }
      }
    }
    listingResult {
      ... on FlightsLoadedListingResult {
        pinnedListingUnavailableMessage
        accessibilityMessage
        appliedFilterAccessibility
        appliedSortingAccessibility
        listings {
          __typename
          ...FlightsSuggestedFilterMessageListing
          ...FlightsStandardOffer
          ...FlightsBargainFareOffer
          ...FlightsFeedback
          ...FlightsCrossSellMessage
        }
        flightsListingsAnalytics {
          onViewedAnalytics {
            ...FlightsAnalytics
          }
          pinnedListingDisplayedAnalytics {
            ...FlightsAnalytics
          }
        }
        listingsAction {
          ...FlightAction
        }
      }
    }
    opinionLab {
      analytics {
        ...FlightsAnalytics
      }
      iconAndLabel {
        icon {
          description
          id
        }
        label
      }
      link
    }
    flightsOpinionLab {
      ... on FlightsActionAndLabel {
        label
        selectAction {
          ...FlightAction
        }
      }
    }
    pageTitle {
      date {
        longMessage
        shortMessage
      }
      subTitle {
        longMessage
        shortMessage
      }
      title {
        longMessage
        shortMessage
      }
    }
    dialogs {
      __typename
      ... on FlightsDialogStaleSession {
        actions {
          ...FlightAction
        }
        animation
        displayedAnalytics {
          ...FlightsAnalytics
        }
        header
        message
        timeoutInSeconds
      }
      __typename
      ... on FlightsDialogForcedChoiceLodgingCrossSell {
        actions {
          ...FlightAction
        }
        animation
        annotation {
          completeText
          items {
            styles
            text
            __typename
            ... on FlightsPhraseLinkNode {
              analytics {
                ...FlightsAnalytics
              }
              link
            }
          }
        }
        header
        subHeader {
          icon {
            id
            description
          }
          label {
            completeText
            items {
              styles
              text
            }
          }
        }
        message
        displayCounter
        hotelDatesTitle
        displayedAnalytics {
          ...FlightsAnalytics
        }
        displayBlockedAnalytics {
          ...FlightsAnalytics
        }
        checkInDate {
          analytics {
            ...FlightsAnalytics
          }
          currentError
          date {
            day
            month
            year
            formatted(format: "d MMM uuuu")
            isoFormat
          }
          dateFormat
          daysBookableInAdvance
          label
          placeholder
          possibleErrors {
            analytics {
              ...FlightsAnalytics
            }
            message
            type
          }
          maxStayDurationAllowed
          possibleErrorsHeader {
            icon {
              id
              description
            }
            label {
              completeText
              items {
                styles
                text
              }
            }
          }
          doneAction
        }
        checkOutDate {
          analytics {
            ...FlightsAnalytics
          }
          currentError
          date {
            day
            month
            year
            formatted(format: "d MMM uuuu")
            isoFormat
          }
          dateFormat
          daysBookableInAdvance
          label
          placeholder
          possibleErrors {
            analytics {
              ...FlightsAnalytics
            }
            message
            type
          }
          maxStayDurationAllowed
          possibleErrorsHeader {
            icon {
              id
              description
            }
            label {
              completeText
              items {
                styles
                text
              }
            }
          }
          doneAction
        }
      }
    }
    banners {
      ...FlightsIconPlacard
    }
    cheapestListingInfo {
      price
      analytics {
        ...FlightsAnalytics
      }
      nffAnalytics {
        ...FlightsAnalytics
      }
      deviationAnalytics {
        ...FlightsAnalytics
      }
    }
    gaiaId
    stepIndicator {
      ...FlightsStepIndicator
    }
  }
}

fragment FlightsBargainFareOffer on FlightsBargainFareOffer {
  bargainOfferAccessibilityMessage: accessibilityMessage
  accessibilityHeading
  bargainPricingInformation {
    cancellationMessage
    loyaltyMessage {
      image {
        description
        url
      }
      label {
        completeText
        items {
          styles
          text
          __typename
          ... on FlightsPhraseLinkNode {
            analytics {
              ...FlightsAnalytics
            }
          }
        }
      }
    }
    price {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            linkName
            rfrr: referrerId
          }
        }
      }
    }
    mainPrice {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            linkName
            rfrr: referrerId
          }
        }
      }
    }
    pricePerTraveler {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    taxesLabel
    totalLabel
    totalPriceForAllTravelers {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    tripType
  }
  description {
    completeText
    items {
      styles
      text
      __typename
      ... on FlightsPhraseLinkNode {
        analytics {
          ...FlightsAnalytics
        }
        link
      }
    }
  }
  header {
    completeText
    items {
      text
      styles
      __typename
      ... on FlightsPhraseLinkNode {
        link
        analytics {
          ...FlightsAnalytics
        }
      }
    }
  }
  image {
    url
  }
  selectOfferAction {
    ...FlightAction
  }
  journeys {
    flightsJourneyAvailableFaresInformation {
      ...FlightsJourneyAvailableFares
    }
  }
}

fragment FlightsSuggestedFilterMessageListing on FlightsSuggestedFilterMessageListing {
  __typename
  suggestedFilterDetails {
    __typename
    ... on FlightsImagePlacard {
      image {
        url
      }
      heading
      message
      actions {
        ... on FlightsAction {
          displayAction
          displayType
          type
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
  }
  suggestedFilter {
    ... on FlightsSuggestedFilterItem {
      selected
      accessibility {
        usage
        onCompletion
      }
      label
      value {
        ... on FlightsFlexibleChangePolicyBasedFilterValue {
          policyName
        }
      }
      type
    }
  }
}

fragment FlightsFeedback on FlightsFeedback {
  __typename
  feedbackLinkAction {
    ...FlightAction
  }
  iconAndLabel {
    icon {
      description
      id
    }
    label
    accessibility
  }
}

fragment MultiItemSearchContext on MultiItemSearchContext {
  flights {
    primary {
      journeyCriterias {
        departureDate {
          day
          month
          year
        }
        origin
        destination
      }
      searchPreferences {
        cabinClass
        advancedFilters
      }
      tripType
      travelers {
        age
        type
      }
    }
  }
}

fragment FlightsCrossSellMessage on FlightsCrossSellMessage {
  __typename
  multiItemFlightCrossSellPrimer {
    flightCrossSellProductType
    multiItemSearchContext {
      ...MultiItemSearchContext
    }
  }
}

fragment FlightsStandardOffer on FlightsStandardOffer {
  __typename
  accessibilityHeading
  accessibilityMessage
  pinnedOfferMessage
  baggageFeesInformation {
    analytics {
      ...FlightsAnalytics
    }
    icon {
      id
      description
    }
    label
    link
  }
  badges {
    accessibilityMessage
    icon {
      description
      id
    }
    text
    type
  }
  journeys {
    airlines {
      image {
        url
        description
      }
      text
    }
    cabinClass
    departureAndArrivalTime {
      completeText
      items {
        styles
        text
      }
    }
    departureAndArrivalLocations
    layoverInformation
    differentDayArrival
    differentDayArrivalAccessibilityMessage
    displayAction {
      id
      description
    }
    durationAndStops
    flightOperatedBy
    label
    urgencyMessage
    urgencyAccessibilityMessage
    stringifiedFlightsJourneyAvailableFaresInformation
    flightsJourneyAvailableFaresInformation {
      flightsJourneyHeaders {
        heading
        flightsJourneySubheadingImage {
          description
          url
        }
        flightsJourneySubheading
      }
      flightsJourneyInformation {
        ...FlightsJourneyInformation
      }
      flightsJourneySummary {
        heading {
          text
          accessibilityMessage
        }
        differentDayArrival {
          text
          accessibilityMessage
        }
        basicFlightDetails {
          text
          accessibilityMessage
        }
      }
      fareChoiceInformation {
        heading {
          longMessage
          shortMessage
        }
        accessibleHeading
        message
        tripTypePerTraveler
        displayAnalytics {
          ...FlightsAnalytics
        }
        scrollAnalytics {
          ...FlightsAnalytics
        }
        fareTypes {
          name
          cabinClass
          accessibilityMessage
          formattedPrice {
            completeText
            items {
              text
              styles
            }
          }
          formattedMainPrice {
            completeText
            items {
              text
              styles
            }
          }
          totalPrice
          identifier
          selected
          clickEventAnalytics {
            ...FlightsAnalytics
          }
          fareScrollAnalytics {
            ...FlightsAnalytics
          }
          collapsedRules {
            ...FlightsJourneyAmenities
          }
          expandedRules {
            ...FlightsJourneyAmenitiesWithLabel
          }
          baggageFeesInformation {
            label
            defaultBagSelectionMessage
            bagFeesMoreInfo {
              completeText
              delimeter
              items {
                __typename
                text
                styles
                ... on FlightsPhraseLinkNode {
                  accessibility
                  analytics {
                    ...FlightsAnalytics
                  }
                  link
                  icon
                }
              }
            }
            displayDetailsAction
            dismissAction
            details {
              topic
              detail
            }
          }
          showMoreToggle {
            ...FlightsToggleSearch
          }
          showMoreAmenitiesToggle {
            ...FlightsToggleSearch
          }
          chooseFareAction {
            analyticsList {
              linkName
              rfrr: referrerId
            }
            displayAction
            displayType
            type
            accessibilityMessage
            relativeURI {
              relativePath
              value
            }
            relativePackageableURI {
              relativePath
              value
            }
            journeySearchCriteria {
              previousFlightSelections {
                journeyIndex
                offerIdentifier
              }
            }
            stepIndicator {
              ...FlightsStepIndicator
            }
          }
          recommendation {
            text
            type
          }
        }
        defaultBaggageInformation {
          label
          defaultBagSelectionMessage
          bagFeesMoreInfo {
            completeText
            delimeter
            items {
              text
            }
          }
          displayDetailsAction
          dismissAction
          details {
            topic
            detail
          }
        }
        hideFareChoiceDetails
      }
      dismissDetailedJourneyInformation {
        icon {
          ...IconSearch
        }
        analytics {
          ...FlightsAnalytics
        }
      }
      openAccessibility
    }
    hygieneAmenitiesMessage
    hygieneAmenitiesPresentation {
      displayAction {
        heading
        onViewedAnalytics {
          ...FlightsAnalytics
        }
      }
      airlineAmenityGroups {
        headerText
        amenities {
          icon {
            id
          }
          label
        }
      }
      disclaimerMessage
    }
  }
  pricingInformation {
    loyaltyMessage {
      image {
        description
        url
      }
      label {
        completeText
        items {
          text
          styles
        }
      }
    }
    price {
      completeText
      items {
        text
        styles
      }
    }
    mainPrice {
      completeText
      items {
        text
        styles
      }
    }
    subPrice {
      completeText
      items {
        text
        styles
      }
    }
    pricePerTraveler {
      completeText
      items {
        text
        styles
      }
    }
    taxesLabel
    totalLabel
    totalPriceForAllTravelers {
      completeText
      items {
        text
        styles
      }
    }
    tripType
  }
  restrictiveFareRules {
    dismissLabel
    displayAction {
      icon {
        id
        description
      }
      label {
        completeText
        items {
          styles
          text
        }
      }
    }
    rules
    title
  }
  selectOfferAction {
    ...FlightAction
  }
  specialFareType
  sponsoredAirline {
    airlineCode
    adUnitID
    advertiserID
    creativeID
    clickTrackingURL
    delayedImpressionURL
    orderID
    sponsoredHeader
    sponsoredText
  }
  tag {
    image {
      description
      url
    }
    message
  }
  flightsOfferAnalytics {
    onViewedAnalytics {
      ...FlightsAnalytics
    }
  }
}

fragment FlightsToggleSearch on FlightsToggle {
  collapseActionable {
    ...TogglePhaseSearch
  }
  expandActionable {
    ...TogglePhaseSearch
  }
  expanded
}
fragment IconSearch on Icon {
  description
  id
  size
  withBackground
}

fragment TogglePhaseSearch on TogglePhase {
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconSearch
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  linkName
  rfrr: referrerId
}

fragment FlightsIconPlacard on FlightsIconPlacard {
  heading
  message
  icon {
    description
    id
  }
  actions {
    ...FlightAction
  }
}

fragment FlightAction on FlightsAction {
  analytics {
    ...FlightsAnalytics
  }
  analyticsList {
    ...FlightsAnalytics
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  type
  accessibilityMessage
  relativeURI {
    relativePath
    value
  }
  relativePackageableURI {
    relativePath
    value
  }
  stepIndicator {
    ...FlightsStepIndicator
  }
  searchPagination {
    ...Pagination
  }
}

fragment FlightsStepIndicator on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}

fragment CoordinateInformationSearch on CoordinateInformation {
  icon {
    ...IconSearch
  }
  overnightMessage
  subtitle
  title
}

fragment FlightsJourneyAvailableFares on FlightsJourneyAvailableFares {
  flightsJourneyHeaders {
    heading
    flightsJourneySubheadingImage {
      description
      url
    }
    flightsJourneySubheading
  }
  flightsJourneyInformation {
    ...FlightsJourneyInformation
  }
  flightsJourneySummary {
    heading {
      text
      accessibilityMessage
    }
    differentDayArrival {
      text
      accessibilityMessage
    }
    basicFlightDetails {
      text
      accessibilityMessage
    }
    __typename
    ... on FlightsBargainJourneySummary {
      formattedPrice {
        completeText
        items {
          text
          styles
        }
      }
      tripTypePerTraveler
      totalPrice
    }
  }
  fareChoiceInformation {
    heading {
      longMessage
      shortMessage
    }
    accessibleHeading
    message
    fareTypes {
      name
      cabinClass
      formattedPrice {
        completeText
        items {
          text
          styles
        }
      }
      identifier
      selected
      collapsedRules {
        ...FlightsJourneyAmenities
      }
      expandedRules {
        ...FlightsJourneyAmenitiesWithLabel
      }
      baggageFeesInformation {
        label
        defaultBagSelectionMessage
        bagFeesMoreInfo {
          completeText
          delimeter
          items {
            text
            styles
            ... on FlightsPhraseLinkNode {
              accessibility
              analytics {
                ...FlightsAnalytics
              }
              link
            }
          }
        }
        displayDetailsAction
        dismissAction
        details {
          topic
          detail
        }
      }
      showMoreToggle {
        ...FlightsToggleSearch
      }
      showMoreAmenitiesToggle {
        ...FlightsToggleSearch
      }
      chooseFareAction {
        ...FlightAction
      }
    }
    defaultBaggageInformation {
      label
      defaultBagSelectionMessage
      bagFeesMoreInfo {
        completeText
        delimeter
        items {
          text
          styles
          ... on FlightsPhraseLinkNode {
            accessibility
            analytics {
              ...FlightsAnalytics
            }
            link
          }
        }
      }
      displayDetailsAction
      dismissAction
      details {
        topic
        detail
      }
    }
  }
  dismissDetailedJourneyInformation {
    icon {
      ...IconSearch
    }
  }
  applySelection {
    ...FlightAction
  }
  flightsJourneyPolicies {
    messages {
      completeText
      items {
        text
        styles
      }
    }
  }
}

fragment FlightsJourneyAmenities on FlightsJourneyAmenities {
  accessibilityMessage
  amenities {
    icon {
      description
      id
      withBackground
    }
    label
    accessibility
  }
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsJourneyAmenitiesWithLabel on FlightsJourneyAmenitiesWithLabel {
  label
  rules {
    ...FlightsJourneyAmenities
  }
}

fragment Pagination on Pagination {
  size
  startingIndex
}

fragment FlightsJourneyInformation on FlightsDetailedJourneyInformation {
  details {
    ...FlightsToggleSearch
  }
  flightJourneyDetails {
    journeyParts {
      connectionAdditionalInformation {
        durationAndStop
        nextFlightOriginAirport
      }
      flightsConnectionInformation {
        flightsConnection {
          aircraftModel
          airlineInfo
          cabinClassAndBookingCode
          connectionArrival {
            ...CoordinateInformationSearch
          }
          connectionDeparture {
            ...CoordinateInformationSearch
          }
          duration
          journeyAmenities {
            accessibilityMessage
            amenities {
              accessibility
              icon {
                ...IconSearch
              }
              label
            }
            analytics {
              ...FlightsAnalytics
            }
          }
        }
        governmentApprovalMessage
      }
    }
  }
}

    `;

export const flightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
  ) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalyticsLoading
        }
      }
    }
    pageTitle {
      date {
        longMessage
        shortMessage
      }
      subTitle {
        longMessage
        shortMessage
      }
      title {
        longMessage
        shortMessage
      }
    }
    listingResult {
      ... on FlightsLoadingListingResult {
        listingsSkeletonCount
        message
        originDestination
        progressBarDetails {
          accessibility {
            initialValue
            template
            tokens
          }
          listingsLatency
          sortAndFilterLatency
        }
        progressBar
      }
    }
    sortAndFilterResult {
      ... on FlightsLoadingSortAndFilterResult {
        filterPresentation {
          __typename
          options {
            __typename
            itemCount
            label
            priceFromLabel
          }
          title
        }
        revealAction {
          iconAndLabel {
            icon {
              id
            }
            label
          }
          enabled
        }
      }
    }
    searchForm {
      __typename
      ... on FlightsLoadingSearchForm {
        addJourneyAction {
          displayAction
          displayType
        }
        departureAndReturnDates {
          longMessage
          shortMessage
        }
        journeys {
          departureDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          label {
            initialValue
            template
            tokens
          }
          destinationLocation {
            icon {
              id
            }
            label
            placeholder
            value
          }
          originLocation {
            icon {
              id
            }
            label
            placeholder
            value
          }
          returnDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          removeJourneyAction {
            displayAction
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
          }
        }
        originAndDestinationLocations
        searchAction
        searchOptions {
          ... on FlightsSearchFormAirlineOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              airline
              label
            }
          }
          ... on FlightsSearchFormCabinClassOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              cabinClass
              label
            }
          }
          ... on FlightsSearchFormMoreFiltersOption {
            __typename
            label
            icon {
              id
            }
          }
          ... on FlightsSearchFormTravelersOption {
            __typename
            label
            icon {
              id
            }
            valueTemplate {
              oneTemplate
              manyTemplate
              tokens
              fewTemplate
              otherTemplate
              twoTemplate
              zeroTemplate
            }
            items {
              __typename
              label
              travelerCount
              type
            }
          }
          ... on FlightsSearchFormTripTypeOption {
            __typename
            icon {
              id
            }
            items {
              label
              selected
              tripType
            }
          }
        }
      }
    }
    failedRequestMessaging {
      icon {
        id
      }
      message
      action {
        analytics {
          ...FlightsAnalyticsLoading
        }
        displayAction
      }
    }
    stepIndicator {
      ...FlightsStepIndicatorLoading
    }
  }
}

fragment FlightsAnalyticsLoading on FlightsAnalytics {
  linkName
  rfrr: referrerId
}

fragment FlightsStepIndicatorLoading on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalyticsLoading
  }
  journeyContinuationId
}

    `;
